export default "/images/slider-5.jpg?c4df6ab2ecbcbc9b87a9d0c6f71ad5dc";